module.exports = __webpack_public_path__ + "static/media/avatars_male_11.4abaf443.png";